export default "__VITE_ASSET__08ac9688__"